import { BaseModel } from './BaseModel';
import Criteria from './Criteria';
import Post from './Post';

export class AdditionalCriterion extends BaseModel {
  static get entity() {
    return 'additional-criterion';
  }

  static get fk() {
    return 'additional_criterion_id';
  }

  static fields() {
    return {
      id: this.uid(),
      title: this.attr(null),
      description: this.attr(null),
      pass_criterion: this.attr(null),
      not_yet_criterion: this.attr(null),
      post_id: this.attr(null),
      post: this.belongsTo(Post, 'post_id'),
      criterion_id: this.attr(null),
      criterion: this.belongsTo(Criteria, 'criterion_id'),
      deleted_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      deleteCriterion(id) {
        return this.delete(`/additional-criterion/${id}`);
      }
    }
  };
}

export default AdditionalCriterion;
